import React, { useState, useRef, useContext } from "react";
import '../../css/integrations.css';
import { fetchWithDefaults } from '../../config/fetchDefault';
import IntegrationBlock from "./integrationBlock";
import { useSelector } from 'react-redux';
import { AgentContext } from "../../context/AgentContext";



function Integrations({ data,title }) {
    const agentInfo=useSelector((state) => state.agent.userData);
    const currentTimestamp = Math.floor(Date.now() / 1000);
    const innerWrapperRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const agentId=agentInfo.agentId;

    let google;
    let calendar=false;
    let gmail=false;
    let zoom=false;
    let quility=false;

    if(data.length > 0){
        google=data[0].googleScopes;

        let zoomed=data[0].zoomAuth;
        if(google && google.includes(`${process.env.REACT_APP_FUNNEL_GOOGLEAPI}/auth/calendar.events`)){
            calendar=true;
        }
        if(google && google.includes(`${process.env.REACT_APP_FUNNEL_GOOGLEAPI}/auth/gmail.send`)){
            gmail=true;
        }
        if(google && google.includes(`${process.env.REACT_APP_FUNNEL_QUILITY}/auth/gmail.send`)){
            quility=true;
        }
        if(zoomed && zoomed !== null){
            zoom=true;
        }
    }
    const getHeight = () => {
        if(innerWrapperRef.current && innerWrapperRef.current.clientHeight===0){
            return 0
        }
        if (innerWrapperRef.current) {
            return innerWrapperRef.current.clientHeight;
        }
        return 0;
    };
    const handleOptionClick = () => {
        setIsOpen(!isOpen);
    };

    let backend_port = process.env.REACT_APP_BACKEND_PORT ? process.env.REACT_APP_BACKEND_PORT : 3333
    const {isB2B} = useContext(AgentContext)
    return (
        <div className={`${isB2B ? 'b2b ' : ''}outerWrapper`} style={{marginTop:'50px', textAlign:'center'}}>
            <span className={`quilityParentBlockWrapper`} style={{ height: isOpen && getHeight() !==0 ? getHeight()+90 : 'fit-content', width:'70%'}} >
                <div className="quilityParentBlockHeader" onClick={()=>handleOptionClick()}>
                    <div className="quilityParentBlockTitle">{title}</div>
                    <span className="quilityBlockIcon"></span>
                </div>
                <div className="quilityParentBlockContent"  ref={innerWrapperRef}>
                    <div className="integrationHoler">
                    <IntegrationBlock removeLink={`/google/revoke`} title={'Google Calendar'} logo="https://app.ninjadialer.com/logo/calendar.png" status={calendar} button="https://app.ninjadialer.com/logo/googleButton.png" link={`https://${window.location.hostname}:${backend_port}/google/auth?agent=${agentId}`}/>
                        <IntegrationBlock removeLink={`/google/revoke`} title={'Gmail'} logo="https://app.ninjadialer.com/logo/gmail.png" status={gmail} button="https://app.ninjadialer.com/logo/googleButton.png" link={`https://${window.location.hostname}:${backend_port}/google/auth/gmail?agent=${agentId}`}/>

                        {/*<IntegrationBlock removeLink={`/google/revoke`} title={'Google Calendar'} logo="https://app.ninjadialer.com/logo/calendar.png" status={calendar} button="https://app.ninjadialer.com/logo/googleButton.png" link={`https://app.ninjadialer.com/userSetup/funnelAuth.php?funnel=&agent=${agentId}`}/>
                        <IntegrationBlock removeLink={`/google/revoke`} title={'Gmail'} logo="https://app.ninjadialer.com/logo/gmail.png" status={gmail} button="https://app.ninjadialer.com/logo/googleButton.png" link={`https://app.ninjadialer.com/userSetup/funnelAuth.php?calendar=&agent=${agentId}`}/>*/}
                        <IntegrationBlock title={'Zoom'} logo="https://app.ninjadialer.com/logo/zoom.png" status={zoom} button="toggle" link={`https://zoom.us/oauth/authorize?response_type=code&client_id=RFjIPVriRaufQ7qgcVAh6w&redirect_uri=https://app.ninjadialer.com/api/zoom/zoom.php?v2agent=${agentId}`}/>
                    </div>
                </div>
            </span>
        </div>
    );
}

export default Integrations;
/*
<IntegrationBlock removeLink={`/google/revoke`} title={'Google Calendar'} logo="https://app.ninjadialer.com/logo/calendar.png" status={calendar} button="https://app.ninjadialer.com/logo/googleButton.png" link={`https://${window.location.hostname}:${backend_port}/google/auth?agent=${agentId}`}/>
                        <IntegrationBlock removeLink={`/google/revoke`} title={'Gmail'} logo="https://app.ninjadialer.com/logo/gmail.png" status={gmail} button="https://app.ninjadialer.com/logo/googleButton.png" link={`https://${window.location.hostname}:${backend_port}/google/auth/gmail?agent=${agentId}`}/>
                        */
// https://app.ninjadialer.com/userSetup/funnelAuth.php?funnel=&agent=ai_bed41293-870d-4cc2-ac13-bc979cac43af
